import { Pipe, PipeTransform } from '@angular/core';
import { FilesPluginService } from './files-plugin.service';

@Pipe({
    name: 'fileToType',
    standalone: false
})
export class FileToTypePipe implements PipeTransform {
  public toTypes: any;

  constructor(private service: FilesPluginService) {
    this.toTypes = this.service.getToTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.toTypes);
  }
}
